import { AddressBookOrder } from "src/views/AssetManagement/Swap/types";

enum FilterFieldsKeys {
  ChainName = "chainName",
  AssetName = "assetName",
  Status = "status",
  AddressBookOrder = "addressBookOrder",
  RiskType = "riskType",
}

type FilterFields = {
  [FilterFieldsKeys.ChainName]: string;
  [FilterFieldsKeys.AssetName]: string;
  [FilterFieldsKeys.Status]: string;
  [FilterFieldsKeys.AddressBookOrder]: AddressBookOrder;
  [FilterFieldsKeys.RiskType]: string;
};

const initFields: FilterFields = {
  [FilterFieldsKeys.AssetName]: "",
  [FilterFieldsKeys.ChainName]: "",
  [FilterFieldsKeys.RiskType]: "",
  [FilterFieldsKeys.AddressBookOrder]: {
    to_address: "",
    amount: "",
    display_name: "",
    wallet_type: "",
    to_wallet_tag: "",
    rawItem: undefined,
  },
  [FilterFieldsKeys.Status]: "",
};

export { FilterFieldsKeys, type FilterFields, initFields };
